/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DeletePlotGeoParams,
  GetPlotsGeoByLocationParams,
  HTTPValidationError,
  PlotGeoBulkCreate,
  PlotGeoBulkUpdate,
  PlotGeoCreate,
  PlotGeoLayoutBulkUpdate,
  PlotGeoLayoutReset,
  PlotGeoLayoutResult,
  PlotGeoResponse,
} from "../model";

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getPlotsGeoByLocationResponse200 = {
  data: PlotGeoResponse[];
  status: 200;
};

export type getPlotsGeoByLocationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getPlotsGeoByLocationResponseSuccess =
  getPlotsGeoByLocationResponse200 & {
    headers: Headers;
  };
export type getPlotsGeoByLocationResponseError =
  getPlotsGeoByLocationResponse422 & {
    headers: Headers;
  };

export type getPlotsGeoByLocationResponse =
  getPlotsGeoByLocationResponseSuccess | getPlotsGeoByLocationResponseError;

export const getGetPlotsGeoByLocationUrl = (
  params?: GetPlotsGeoByLocationParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/plots-geo/?${stringifiedParams}`
    : `/api/plots-geo/`;
};

/**
 * @summary Get Plots Geo By Location Route
 */
export const getPlotsGeoByLocation = async (
  params?: GetPlotsGeoByLocationParams,
  options?: RequestInit,
): Promise<getPlotsGeoByLocationResponse> => {
  const res = await fetch(getGetPlotsGeoByLocationUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getPlotsGeoByLocationResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getPlotsGeoByLocationResponse;
};

export const getGetPlotsGeoByLocationQueryKey = (
  params?: GetPlotsGeoByLocationParams,
) => {
  return [`/api/plots-geo/`, ...(params ? [params] : [])] as const;
};

export const getGetPlotsGeoByLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetPlotsGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlotsGeoByLocationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlotsGeoByLocation>>
  > = ({ signal }) =>
    getPlotsGeoByLocation(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlotsGeoByLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlotsGeoByLocation>>
>;
export type GetPlotsGeoByLocationQueryError = HTTPValidationError;

export function useGetPlotsGeoByLocation<
  TData = Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetPlotsGeoByLocationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
          TError,
          Awaited<ReturnType<typeof getPlotsGeoByLocation>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlotsGeoByLocation<
  TData = Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetPlotsGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
          TError,
          Awaited<ReturnType<typeof getPlotsGeoByLocation>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlotsGeoByLocation<
  TData = Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetPlotsGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Plots Geo By Location Route
 */

export function useGetPlotsGeoByLocation<
  TData = Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetPlotsGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlotsGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPlotsGeoByLocationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createPlotGeoResponse200 = {
  data: PlotGeoResponse;
  status: 200;
};

export type createPlotGeoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createPlotGeoResponseSuccess = createPlotGeoResponse200 & {
  headers: Headers;
};
export type createPlotGeoResponseError = createPlotGeoResponse422 & {
  headers: Headers;
};

export type createPlotGeoResponse =
  createPlotGeoResponseSuccess | createPlotGeoResponseError;

export const getCreatePlotGeoUrl = () => {
  return `/api/plots-geo/`;
};

/**
 * @summary Create Plot Geo Route
 */
export const createPlotGeo = async (
  plotGeoCreate: PlotGeoCreate,
  options?: RequestInit,
): Promise<createPlotGeoResponse> => {
  const res = await fetch(getCreatePlotGeoUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(plotGeoCreate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createPlotGeoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createPlotGeoResponse;
};

export const getCreatePlotGeoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlotGeo>>,
    TError,
    { data: PlotGeoCreate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPlotGeo>>,
  TError,
  { data: PlotGeoCreate },
  TContext
> => {
  const mutationKey = ["createPlotGeo"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPlotGeo>>,
    { data: PlotGeoCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createPlotGeo(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlotGeoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPlotGeo>>
>;
export type CreatePlotGeoMutationBody = PlotGeoCreate;
export type CreatePlotGeoMutationError = HTTPValidationError;

/**
 * @summary Create Plot Geo Route
 */
export const useCreatePlotGeo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPlotGeo>>,
      TError,
      { data: PlotGeoCreate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPlotGeo>>,
  TError,
  { data: PlotGeoCreate },
  TContext
> => {
  return useMutation(getCreatePlotGeoMutationOptions(options), queryClient);
};
export type createPlotsGeoBulkResponse200 = {
  data: PlotGeoResponse[];
  status: 200;
};

export type createPlotsGeoBulkResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createPlotsGeoBulkResponseSuccess =
  createPlotsGeoBulkResponse200 & {
    headers: Headers;
  };
export type createPlotsGeoBulkResponseError = createPlotsGeoBulkResponse422 & {
  headers: Headers;
};

export type createPlotsGeoBulkResponse =
  createPlotsGeoBulkResponseSuccess | createPlotsGeoBulkResponseError;

export const getCreatePlotsGeoBulkUrl = () => {
  return `/api/plots-geo/bulk`;
};

/**
 * Create many plot boundaries for one trial (e.g. a grid).
 * @summary Create Plots Geo Bulk Route
 */
export const createPlotsGeoBulk = async (
  plotGeoBulkCreate: PlotGeoBulkCreate,
  options?: RequestInit,
): Promise<createPlotsGeoBulkResponse> => {
  const res = await fetch(getCreatePlotsGeoBulkUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(plotGeoBulkCreate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createPlotsGeoBulkResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createPlotsGeoBulkResponse;
};

export const getCreatePlotsGeoBulkMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlotsGeoBulk>>,
    TError,
    { data: PlotGeoBulkCreate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPlotsGeoBulk>>,
  TError,
  { data: PlotGeoBulkCreate },
  TContext
> => {
  const mutationKey = ["createPlotsGeoBulk"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPlotsGeoBulk>>,
    { data: PlotGeoBulkCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createPlotsGeoBulk(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlotsGeoBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPlotsGeoBulk>>
>;
export type CreatePlotsGeoBulkMutationBody = PlotGeoBulkCreate;
export type CreatePlotsGeoBulkMutationError = HTTPValidationError;

/**
 * @summary Create Plots Geo Bulk Route
 */
export const useCreatePlotsGeoBulk = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPlotsGeoBulk>>,
      TError,
      { data: PlotGeoBulkCreate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPlotsGeoBulk>>,
  TError,
  { data: PlotGeoBulkCreate },
  TContext
> => {
  return useMutation(
    getCreatePlotsGeoBulkMutationOptions(options),
    queryClient,
  );
};
export type updatePlotsGeoBulkResponse200 = {
  data: PlotGeoResponse[];
  status: 200;
};

export type updatePlotsGeoBulkResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updatePlotsGeoBulkResponseSuccess =
  updatePlotsGeoBulkResponse200 & {
    headers: Headers;
  };
export type updatePlotsGeoBulkResponseError = updatePlotsGeoBulkResponse422 & {
  headers: Headers;
};

export type updatePlotsGeoBulkResponse =
  updatePlotsGeoBulkResponseSuccess | updatePlotsGeoBulkResponseError;

export const getUpdatePlotsGeoBulkUrl = () => {
  return `/api/plots-geo/bulk`;
};

/**
 * Update many plot boundaries in one request.
 *
 * Overlap checks match CSV upload: new polygons are compared with each
 * other, and existing plots in this payload are excluded so adjacent
 * cells can move together without hitting each other's old boundaries.
 * @summary Update Plots Geo Bulk Route
 */
export const updatePlotsGeoBulk = async (
  plotGeoBulkUpdate: PlotGeoBulkUpdate,
  options?: RequestInit,
): Promise<updatePlotsGeoBulkResponse> => {
  const res = await fetch(getUpdatePlotsGeoBulkUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(plotGeoBulkUpdate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updatePlotsGeoBulkResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as updatePlotsGeoBulkResponse;
};

export const getUpdatePlotsGeoBulkMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlotsGeoBulk>>,
    TError,
    { data: PlotGeoBulkUpdate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlotsGeoBulk>>,
  TError,
  { data: PlotGeoBulkUpdate },
  TContext
> => {
  const mutationKey = ["updatePlotsGeoBulk"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlotsGeoBulk>>,
    { data: PlotGeoBulkUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updatePlotsGeoBulk(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlotsGeoBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlotsGeoBulk>>
>;
export type UpdatePlotsGeoBulkMutationBody = PlotGeoBulkUpdate;
export type UpdatePlotsGeoBulkMutationError = HTTPValidationError;

/**
 * @summary Update Plots Geo Bulk Route
 */
export const useUpdatePlotsGeoBulk = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlotsGeoBulk>>,
      TError,
      { data: PlotGeoBulkUpdate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlotsGeoBulk>>,
  TError,
  { data: PlotGeoBulkUpdate },
  TContext
> => {
  return useMutation(
    getUpdatePlotsGeoBulkMutationOptions(options),
    queryClient,
  );
};
export type updatePlotsGeoLayoutBulkResponse200 = {
  data: PlotGeoLayoutResult[];
  status: 200;
};

export type updatePlotsGeoLayoutBulkResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updatePlotsGeoLayoutBulkResponseSuccess =
  updatePlotsGeoLayoutBulkResponse200 & {
    headers: Headers;
  };
export type updatePlotsGeoLayoutBulkResponseError =
  updatePlotsGeoLayoutBulkResponse422 & {
    headers: Headers;
  };

export type updatePlotsGeoLayoutBulkResponse =
  | updatePlotsGeoLayoutBulkResponseSuccess
  | updatePlotsGeoLayoutBulkResponseError;

export const getUpdatePlotsGeoLayoutBulkUrl = () => {
  return `/api/plots-geo/layout/bulk`;
};

/**
 * Update plot outlines and the rows that split them in one request.
 *
 * Only boundaries are written. Each plot must include every row of that
 * plot. Row checks use the plot polygon in this request, so a move and a
 * size change can be saved together.
 * @summary Update Plots Geo Layout Bulk Route
 */
export const updatePlotsGeoLayoutBulk = async (
  plotGeoLayoutBulkUpdate: PlotGeoLayoutBulkUpdate,
  options?: RequestInit,
): Promise<updatePlotsGeoLayoutBulkResponse> => {
  const res = await fetch(getUpdatePlotsGeoLayoutBulkUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(plotGeoLayoutBulkUpdate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updatePlotsGeoLayoutBulkResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as updatePlotsGeoLayoutBulkResponse;
};

export const getUpdatePlotsGeoLayoutBulkMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlotsGeoLayoutBulk>>,
    TError,
    { data: PlotGeoLayoutBulkUpdate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlotsGeoLayoutBulk>>,
  TError,
  { data: PlotGeoLayoutBulkUpdate },
  TContext
> => {
  const mutationKey = ["updatePlotsGeoLayoutBulk"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlotsGeoLayoutBulk>>,
    { data: PlotGeoLayoutBulkUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updatePlotsGeoLayoutBulk(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlotsGeoLayoutBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlotsGeoLayoutBulk>>
>;
export type UpdatePlotsGeoLayoutBulkMutationBody = PlotGeoLayoutBulkUpdate;
export type UpdatePlotsGeoLayoutBulkMutationError = HTTPValidationError;

/**
 * @summary Update Plots Geo Layout Bulk Route
 */
export const useUpdatePlotsGeoLayoutBulk = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlotsGeoLayoutBulk>>,
      TError,
      { data: PlotGeoLayoutBulkUpdate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlotsGeoLayoutBulk>>,
  TError,
  { data: PlotGeoLayoutBulkUpdate },
  TContext
> => {
  return useMutation(
    getUpdatePlotsGeoLayoutBulkMutationOptions(options),
    queryClient,
  );
};
export type resetPlotsGeoLayoutResponse200 = {
  data: PlotGeoLayoutResult[];
  status: 200;
};

export type resetPlotsGeoLayoutResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type resetPlotsGeoLayoutResponseSuccess =
  resetPlotsGeoLayoutResponse200 & {
    headers: Headers;
  };
export type resetPlotsGeoLayoutResponseError =
  resetPlotsGeoLayoutResponse422 & {
    headers: Headers;
  };

export type resetPlotsGeoLayoutResponse =
  resetPlotsGeoLayoutResponseSuccess | resetPlotsGeoLayoutResponseError;

export const getResetPlotsGeoLayoutUrl = () => {
  return `/api/plots-geo/reset`;
};

/**
 * Clear every plot and row boundary for a trial so the layout can be redrawn.
 *
 * Plot labels, row numbers, and the records themselves are kept. The request
 * fails when any row in the trial has a snip, including one that has already
 * been analyzed.
 * @summary Clear plot and row boundaries for a trial
 */
export const resetPlotsGeoLayout = async (
  plotGeoLayoutReset: PlotGeoLayoutReset,
  options?: RequestInit,
): Promise<resetPlotsGeoLayoutResponse> => {
  const res = await fetch(getResetPlotsGeoLayoutUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(plotGeoLayoutReset),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: resetPlotsGeoLayoutResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as resetPlotsGeoLayoutResponse;
};

export const getResetPlotsGeoLayoutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPlotsGeoLayout>>,
    TError,
    { data: PlotGeoLayoutReset },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPlotsGeoLayout>>,
  TError,
  { data: PlotGeoLayoutReset },
  TContext
> => {
  const mutationKey = ["resetPlotsGeoLayout"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPlotsGeoLayout>>,
    { data: PlotGeoLayoutReset }
  > = (props) => {
    const { data } = props ?? {};

    return resetPlotsGeoLayout(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetPlotsGeoLayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetPlotsGeoLayout>>
>;
export type ResetPlotsGeoLayoutMutationBody = PlotGeoLayoutReset;
export type ResetPlotsGeoLayoutMutationError = HTTPValidationError;

/**
 * @summary Clear plot and row boundaries for a trial
 */
export const useResetPlotsGeoLayout = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetPlotsGeoLayout>>,
      TError,
      { data: PlotGeoLayoutReset },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resetPlotsGeoLayout>>,
  TError,
  { data: PlotGeoLayoutReset },
  TContext
> => {
  return useMutation(
    getResetPlotsGeoLayoutMutationOptions(options),
    queryClient,
  );
};
export type deletePlotGeoResponse200 = {
  data: PlotGeoResponse;
  status: 200;
};

export type deletePlotGeoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deletePlotGeoResponseSuccess = deletePlotGeoResponse200 & {
  headers: Headers;
};
export type deletePlotGeoResponseError = deletePlotGeoResponse422 & {
  headers: Headers;
};

export type deletePlotGeoResponse =
  deletePlotGeoResponseSuccess | deletePlotGeoResponseError;

export const getDeletePlotGeoUrl = (
  plotGeoId: number,
  params?: DeletePlotGeoParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/plots-geo/${plotGeoId}?${stringifiedParams}`
    : `/api/plots-geo/${plotGeoId}`;
};

/**
 * Soft-clear the boundary polygon and record ``user_id`` (row is kept).
 * @summary Delete Plot Geo Route
 */
export const deletePlotGeo = async (
  plotGeoId: number,
  params?: DeletePlotGeoParams,
  options?: RequestInit,
): Promise<deletePlotGeoResponse> => {
  const res = await fetch(getDeletePlotGeoUrl(plotGeoId, params), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deletePlotGeoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as deletePlotGeoResponse;
};

export const getDeletePlotGeoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlotGeo>>,
    TError,
    { plotGeoId: number; params?: DeletePlotGeoParams },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePlotGeo>>,
  TError,
  { plotGeoId: number; params?: DeletePlotGeoParams },
  TContext
> => {
  const mutationKey = ["deletePlotGeo"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePlotGeo>>,
    { plotGeoId: number; params?: DeletePlotGeoParams }
  > = (props) => {
    const { plotGeoId, params } = props ?? {};

    return deletePlotGeo(plotGeoId, params, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePlotGeoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePlotGeo>>
>;

export type DeletePlotGeoMutationError = HTTPValidationError;

/**
 * @summary Delete Plot Geo Route
 */
export const useDeletePlotGeo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePlotGeo>>,
      TError,
      { plotGeoId: number; params?: DeletePlotGeoParams },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePlotGeo>>,
  TError,
  { plotGeoId: number; params?: DeletePlotGeoParams },
  TContext
> => {
  return useMutation(getDeletePlotGeoMutationOptions(options), queryClient);
};
